module.exports = __webpack_public_path__ + "static/media/img_5.1fb09b1b.png";